// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reconnect-tenant-banner{display:flex;flex-direction:row;align-items:center;justify-content:space-around;width:55%;max-width:940px;margin:auto;padding:8px;background-color:var(--melon-20);border-radius:25px}.reconnect-tenant-inner{display:flex;flex-direction:row;align-items:center}.reconnect-tenant-inner .svg-icon-alert-triangle{margin-right:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
